const subscription = {
    limit_exceeded: 'Osiągnąłeś limit swojego planu subskrypcji.',
    get_plan_failed: 'Nie można pobrać planu subskrypcji dla najemcy.',
    tenant_suspended: 'Najemca jest zawieszony. Skontaktuj się z administratorem.',
};
export default Object.freeze(subscription);
